export default __webpack_public_path__ + "static/media/Rectangle40.182d1795.svg";